import React from 'react';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';

import { ModalWrapper, CloseButton, ModalDescription } from './styles';

export function NumberAttemptsModal({ number, handleClose }) {
  const descriptionStyle = {
    color: number === 1 ? 'red' : 'inherit',
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="success-modal-title"
      aria-describedby="success-modal-description"
      disableBackdropClick 
    >
      <ModalWrapper>
        <CloseButton onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
        <ModalDescription id="success-modal-description" style={descriptionStyle}>
          {`Senha inválida. Você tem mais 0${number} `}
          {number === 1 ? (
            <>tentativa<strong> antes do bloqueio da senha.</strong></>
          ) : (
            <>tentativas antes do bloqueio da senha.</>
          )}
        </ModalDescription>
      </ModalWrapper>
    </Modal>
  );
}
